import React from 'react';
import { Menu } from "antd";
import './style.scss';
import { useDispatch } from 'react-redux';
import { logout } from '../../features/authSlice';
import { useSelector } from 'react-redux';

import {
  EnvironmentOutlined,
  GroupOutlined,
  HomeOutlined,
  InfoCircleOutlined,
  InfoOutlined,
  UserOutlined,
  FundProjectionScreenOutlined,
  FileTextOutlined,
  BarChartOutlined,
  DiffOutlined,
  PartitionOutlined,
  SwapOutlined,
  DatabaseOutlined,
  DashboardOutlined,
  ArrowRightOutlined,
  LinkOutlined,
  WarningOutlined,
  SettingOutlined,
  SafetyOutlined,
} from '@ant-design/icons';
import { Link, useLocation } from 'react-router-dom';
import RoleUtils from '../../utils/RoleUtils';

export default function Sidebar() {
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const auth = useSelector((state) => state.auth);

  const isHidden = true;

  const items = [
    { key: '/', label: <Link to={`/`}>Home</Link>, icon: <HomeOutlined /> },
    {
      key: 'data',
      label: <strong>Data Tools</strong>,
      icon: <DatabaseOutlined />,
      type: 'sub-menu',
      children: [
        { key: '/data_query', label: <Link to={`/data_query`}>Data Query</Link>, icon: <InfoOutlined /> },
        { key: '/aggregation_query', label: <Link to={`/aggregation_query`}>Aggregation Query</Link>, icon: <InfoOutlined /> },
        { key: '/summary_table', label: <Link to={`/summary_table`}>Summary Table</Link>, icon: <InfoOutlined /> },
        { key: '/carry', label: <Link to={`/carry`}>Carry Data</Link>, icon: <LinkOutlined /> },
        //{ key: '/growth_rate', label: <Link to={`/growth_rate`}>Growth Rate</Link>, icon: <DiffOutlined /> },
        { key: '/data_overview', label: <Link to={`/data_overview`}>Data Overview</Link>, icon: <BarChartOutlined /> },
        !isHidden && {
          key: '/data_first_last_year', 
          label: <Link to={'/data_first_last_year'}>Data First-Last Year</Link>, 
          icon: <DiffOutlined /> 
        },
        RoleUtils.canManageAggregations(user.role) && { key: '/manage_aggregations', label: <Link to={`/manage_aggregations`}>Manage Aggregations</Link>, icon: <InfoOutlined /> },
      ],
    },
    ...(RoleUtils.canManageMetadata(user.role)
      ? [
          {
            key: 'metadata',
            label: <strong>Metadata Tools</strong>,
            icon: <DashboardOutlined />,
            type: 'sub-menu',
            children: [
              !isHidden && { key: '/php_data_comparator', label: <Link to={`/php_data_comparator`}>PHP Comparator</Link>, icon: <SwapOutlined /> },
              !isHidden && RoleUtils.isAdmin(user.role) && { key: '/data-matching', label: <Link to={`/data-matching`}>Data Matching</Link>, icon: <ArrowRightOutlined /> },
              RoleUtils.canManageMetadata(user.role) && { key: '/csv_uploader', label: <Link to={`/csv_uploader`}>CSV Uploader</Link>, icon: <FileTextOutlined /> },
              { key: '/syb', label: <Link to={`/syb`}>SYB</Link>, icon: <FileTextOutlined />},
              { key: '/auto_fetch', label: <Link to={`/auto_fetch`}>Auto Fetch</Link>, icon: <FileTextOutlined /> },
              false && { key: '/data_security', label: <Link to={`/data_security`}>Data Security</Link>, icon: <WarningOutlined /> },
              { key: '/categories', label: <Link to={`/categories`}>Categories</Link>, icon: <GroupOutlined /> },
              { key: '/countries', label: <Link to={`/countries`}>Countries</Link>, icon: <EnvironmentOutlined /> },
              { key: '/concordance_table', label: <Link to={`/concordance_table`}>Concordance Table</Link>, icon: <PartitionOutlined /> },
              { key: '/region_table', label: <Link to={`/region_table`}>Region Table</Link>, icon: <PartitionOutlined /> },
              { key: '/indicators', label: <Link to={`/indicators`}>Indicators</Link>, icon: <InfoOutlined /> },
              !isHidden && { key: '/data_management', label: <Link to={`/data_management`}>Data Management</Link>, icon: <DatabaseOutlined /> },
              { key: '/custom_formula_calculation', label: <Link to={`/custom_formula_calculation`}>Custom Formula Calculation</Link>, icon: <FundProjectionScreenOutlined /> },
              { key: '/units', label: <Link to={`/units`}>Units</Link>, icon: <FundProjectionScreenOutlined /> },
              { key: '/source', label: <Link to={`/source`}>Source</Link>, icon: <InfoOutlined /> },
              RoleUtils.isAdmin(user.role) && { key: 'admin_panel', label: <Link to={`/admin_panel`}>Admin Panel</Link>, icon: <InfoOutlined /> },
              { key: '/cif-admin', label: <Link to={`/cif-admin`}>CIF Data</Link>, icon: <SafetyOutlined /> },
              { key: '/tbf-admin', label: <Link to={`/tbf-admin`}>TBF</Link>, icon: <SafetyOutlined /> },
            ].filter(x => x !== null),
          },
        ]
      : []),
    RoleUtils.isAdmin(user.role) && { key: '/users', label: <Link to={`/users`}>Users</Link>, icon: <UserOutlined /> },
    RoleUtils.isAdmin(user.role) && { key: '/log_viewer', label: <Link to={`/log_viewer`}>Log Viewer</Link>, icon: <InfoCircleOutlined /> },
    { key: '/about', label: <Link to={`/about`}>About</Link>, icon: <InfoCircleOutlined /> },
    { key: '/settings', label: <Link to={`/settings`}>Settings</Link>, icon: <SettingOutlined /> },
    { key: 'logout', label: `Logout (${user.username})`, icon: <UserOutlined /> },
  ].filter(x => x !== null);
  
  const normalizePath = pathname => `/${pathname.split('/')[1]}`;

  const selectedKeys = items
    .flatMap(item => item.children ? item.children.map(child => child.key) : item.key)
    .filter(key => key === normalizePath(pathname));
  
  const handleLogout = () => {
    dispatch(logout());
  };
  return (
    <Menu theme="dark" mode="inline" defaultOpenKeys={['data']} selectedKeys={selectedKeys} items={items} onClick={({ key }) => {
      if (key === 'logout') {
        handleLogout();
      }
    }} />
  );
}